<div class="form-modal modal-theme">
  <h1 mat-dialog-title>{{'NOTES'|translate}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="form" class="form-horizontal modal-dialog-custom">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <div class="col-md-3 col-sm-12">
              <mat-form-field class="allwidth" [ngClass]="{'mat-input-invalid':formErrors.Name || !form.controls.Name.valid}">
                <mat-label>{{'NAME' | translate}}</mat-label>
                <input matInput formControlName="Name"/>
              </mat-form-field>
              <span *ngIf="formErrors.Name" class="field-validation-valid text-danger"
                [translate] [translateParams]="formErrorsParam.Name">{{ formErrors.Name }}</span>
            </div>
            <div class="col-md-3 col-sm-12">
              <mat-form-field class="allwidth" *ngIf="contexts">
                <mat-label>{{ 'CONTEXT' | translate }}</mat-label>
                <mat-select formControlName="Context">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="
                      let context of contexts
                    " [value]="context.Context">
                    {{ context.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <span *ngIf="formErrors.Context" class="field-validation-valid text-danger"
                [translate] [translateParams]="
                  formErrorsParam.Context
                ">{{ formErrors.Context }}</span>
            </div>
            <div class="col-md-12 col-sm-12 spacer-bottom-xs"></div>
            <div class="col-md-3 col-sm-12">
              <mat-form-field class="allwidth" *ngIf="integrationsProfiles">
                <mat-label>{{ 'FILESINTEGRATIONROLEID' | translate }}</mat-label>
                <mat-select formControlName="FilesIntegrationRoleID">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="
                      let integrationProfile of integrationsProfiles
                    " [value]="integrationProfile.ID">
                    {{ integrationProfile.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <span *ngIf="formErrors.FilesIntegrationRoleID" class="field-validation-valid text-danger"
                [translate] [translateParams]="
                  formErrorsParam.FilesIntegrationRoleID
                ">{{ formErrors.FilesIntegrationRoleID }}</span>
            </div>
            <div class="col-md-3 col-sm-12">
              <mat-form-field class="allwidth" *ngIf="integrationsProfiles">
                <mat-label>{{ 'FILEINTEGRATIONID' | translate }}</mat-label>
                <mat-select formControlName="FileIntegrationID">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="
                      let integrationProfile of integrationsProfiles
                    " [value]="integrationProfile.ID">
                    {{ integrationProfile.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <span *ngIf="formErrors.FileIntegrationID" class="field-validation-valid text-danger"
                [translate] [translateParams]="
                  formErrorsParam.FileIntegrationID
                ">{{ formErrors.FileIntegrationID }}</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <!-- Edição -->
    <div class="full-width text-right" *ngIf="!disabled">
      <button type="button" class="btn btn-default" [title]="'BUTTON.CANCEL'|translate" (click)="dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL'|translate}}
      </button>
      <button type="button" class="btn btn-primary" [title]="'BUTTON.SAVE'|translate" (click)="save()"
        [disabled]="!form.valid || (!changedForm && enableSavingWhenChangingForm)">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE'|translate}}
      </button>
    </div>
  </div>
</div>